import React, {useEffect} from 'react';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import FeedbackRegister from 'components/ModalFeedbackRegister/FeedbackRegister';
import StorageService from 'services/StorageService/';
import { actionsType } from 'config/constants';
import { primeInvitation, primeFlag } from 'config';
import CMSFactory from 'factories/CMS';

let actions = [];

const ModalFeedbackRegister = () => {

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.FEEDBACK_REGISTER_CLOSE, _openDrawerPrime));

        return function cleanup() {
            _openDrawerPrime()
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, [])

    function _openDrawerPrime () {
        if(!primeFlag) return false;

        const userData = StorageService.getSecureItem('userData');
        const datePrime = CMSFactory.milliseconds(primeInvitation) < CMSFactory.milliseconds(userData.prime_invitation_date);

        if(!(userData.CencoPrime_2020 || userData.CencoPrime_CAT) && (!userData.prime_invitation_date || datePrime)) {
            setTimeout(() => PubSub.dispatch('drawer_prime_invitation_open'), 300);
        }
    }

    return (
        <Modal customClass='modal-feedback-register' actionOpen={actionsType.MODAL.FEEDBACK_REGISTER_OPEN} actionClose={actionsType.MODAL.FEEDBACK_REGISTER_CLOSE}>
            <FeedbackRegister _openDrawerPrime={_openDrawerPrime}/>
        </Modal>
    );
}

export default ModalFeedbackRegister;
